import Panel from "../panel/Panel";
import {useEffect, useState} from "react";
import {getCheckoutHistory} from "../../api/getCheckoutHistory";
import useUserContext from "../../hooks/useUserContext";
import CheckoutPanelStep from "./CheckoutPanelStep";
import "./checkout-panel.css";

const CheckoutPanel = ({ checkoutId, onClose }: { checkoutId?: number, onClose: () => void }) => {
    const { selectedDomain } = useUserContext();
    const [checkoutHistory, setCheckoutHistory] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(false);
    const loadCheckout = async () => {
        if(selectedDomain && checkoutId) {
            setIsLoading(true);
            const checkoutHistoryResponse = await getCheckoutHistory(selectedDomain, checkoutId);
            setIsLoading(false);
            console.log("checkoutHistory: ", checkoutHistoryResponse);
            setCheckoutHistory(checkoutHistoryResponse?.data || []);
        } else {
            setCheckoutHistory([]);
        }
    }

    useEffect(() => {
        loadCheckout();
    }, [checkoutId]);

    return <Panel width={450} isOpen={!!checkoutId} onClose={onClose} className="checkout-panel">
        {checkoutHistory.map((step: any) => <CheckoutPanelStep step={step} />)}
    </Panel>
}

export default CheckoutPanel;